import { render, staticRenderFns } from "./ResourceVideoModal.vue?vue&type=template&id=066fbde8&"
import script from "./ResourceVideoModal.vue?vue&type=script&lang=js&"
export * from "./ResourceVideoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports